<template>
  <div class="modal-title">
    <h3>Wat kon er beter?</h3>
  </div>
  <div class="improvement-reasons">
    <CheckboxInput v-for="option in frankStore.improvement_options"
              v-bind="option"
              v-model="frankStore.feedback.improvements" :name="option.value"
    >
      {{ option.label }}
    </CheckboxInput>
  </div>
  <div class="user-data component-spacing-top">
    <TextInput id="frank_message" v-model="frankStore.feedback.message" label="Jouw bericht"></TextInput>
    <TextInput id="frank_email"  v-model="frankStore.feedback.email" label="E-mailadres"></TextInput>
  </div>
  <div class="navigation-bar component-spacing-top">
    <LinkIconLeft
        @click.native="frankStore.goBack()"
        icon="arrow-left-long-solid"
        label="Ga terug"
    >

    </LinkIconLeft>

    <ButtonIconRight
        @click.native="frankStore.submitFeedback()"
        type="cta"
        label="Verstuur feedback"
    >
    </ButtonIconRight>
  </div>
</template>

<script setup>
import { useFrankStore } from './store/frankStore.js';
import LinkIconLeft from '../../../abstracts/elements/link/icon-left/link-icon-left.vue';
import ButtonIconRight from '../../../abstracts/elements/button/icon-right/button-icon-right.vue';
import TextInput from '../../vue-elements/input/TextInput.vue';
import CheckboxInput from '../../vue-elements/input/CheckboxInput.vue';

const frankStore = useFrankStore();

</script>
